(function () {
  function svela(t) {
    return t.split('').reverse().join('').replace('!', String.fromCharCode(64));
  }
  function accendi(a, t) {
    if (!t) return;
    var v = svela(t);
    a.setAttribute('href', 'mailto:' + v);
    if (!a.textContent.trim()) {
      a.textContent = v;
    }
  }
  function tutti() {
    var d = document.querySelectorAll('a.ms-recapito[data-r]');
    for (var i = 0; i < d.length; i++) {
      accendi(d[i], d[i].getAttribute('data-r'));
      d[i].removeAttribute('data-r');
    }
    var f = document.querySelectorAll('a[href^="#r-"]');
    for (var j = 0; j < f.length; j++) {
      accendi(f[j], f[j].getAttribute('href').slice(3));
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', tutti);
  } else {
    tutti();
  }
  document.addEventListener('shopify:section:load', tutti);
})();
